<template>
  <a-modal
    :visible="visible"
    :width="1000"
    title="选择项目"
    :footer="null"
    @cancel="$emit('cancel')"
  >
    <div class="pb-6 overflow-hidden">
      <div class="float-left overflow-hidden">
        <span class="float-left pr-2 leading-8">搜索:</span>
        <a-textarea
          class="float-left"
          style="width: 200px"
          autoSize
          v-model="queryParam.custom.search"
          placeholder="请输入要搜索的内容"
          @pressEnter="press_enter"
        ></a-textarea>
      </div>
      <div class="float-left pl-6">
        <a-button type="primary" class="mr-2" @click="gets(1)">搜索</a-button>
        <a-button type="default" @click="reset">重置</a-button>
      </div>
    </div>
    <a-table
      :loading="loading"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      bordered
      row-key="id"
      size="small"
      :customRow="customRow"
    >
      <template slot="action" slot-scope="text, record">
        <span>
          <a @click="select(record)" class="text-green-500">选择</a>
        </span>
      </template>
    </a-table>
  </a-modal>
</template>
<script>
import { users } from '@/api/user';
import { columns } from './_user';
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      columns,
      queryParam: { custom: {}, time: {}, eq: { ggb: 'linhai' } },
      loading: true,
      pagination: {
        current: 1,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page;
          this.gets();
        },
      },
      list: [],
    };
  },
  watch: {
    visible(a) {
      if (a) {
        this.gets(1);
      }
    },
  },
  methods: {
    customRow(record) {
      return {
        on: {
          dblclick: (event) => {
            this.$emit('ok', record);
          },
        },
      };
    },
    async gets(current) {
      this.loading = true;
      if (current) {
        this.pagination.current = current;
      }
      let res = await users({
        current: this.pagination.current,
        qp: JSON.stringify(this.queryParam),
      });
      this.list = res.data || [];
      this.$set(this.pagination, 'total', res.total);
      this.loading = false;
    },
    select(record) {
      this.$emit('ok', record);
    },
    reset() {
      this.queryParam = { custom: { search: '' }, time: {} };
      this.gets(1);
    },
    press_enter(e) {
      e.preventDefault();
      this.gets(1);
    },
  },
};
</script>
